<template>
  <div class="notifications-item-study-messagee">
    <div class="notifications-item-study-messagee__header">
      <div class="notifications-item-study-messagee__profile">
        <StudyConversationMessageAvatar
          :message="message"
          small
          is-compact-layout
          :stream-parameters="streamParameters"
          class="notifications-item-study-messagee__avatar"
        />
        <StudyConversationMessageProfileName
          class="StudyConversationMessageHeader__profile"
          :message="message"
          :stream-parameters="streamParameters"
          is-compact-layout
        />
      </div>
      <LLTimestamp class="notifications-item-study-messagee__timestamp" :timestamp="notification.createdAt">
        <template #default="data">
          {{ data.time }}
        </template>
      </LLTimestamp>
    </div>
    <StudyConversationMessageBodyText
      ref="text"
      class="notifications-item-study-messagee__body"
      :message="message"
      :options="options"
      :stream-parameters="streamParameters"
      is-compact-layout
      truncated
      truncate-lines="2"
    />
  </div>
</template>

<script>
import { NotificationModel } from '@/models/notification'
import LLTimestamp from '@/components/common/LLTimestamp.vue'
import StudyConversationMessageProfileName from '@/components/modules/study/study-conversation-message/StudyConversationMessageProfileName.vue'
import StudyConversationMessageAvatar from '@/components/modules/study/study-conversation-message/StudyConversationMessageAvatar.vue'
import StudyConversationMessageBodyText from '@/components/modules/study/study-conversation-message/body/StudyConversationMessageBodyText.vue'
import {
  StudyConversationMessageFileSize,
  StudyConversationMessageOptionsModel,
  StudyConversationMessageType
} from '@/models/studyConversationMessage/studyConversationMessageOptions'
import { StudyConversationMessageStreamParametersModel } from '@/models/studyConversationMessage/studyConversationMessageStreamParameters'

export default {
  name: 'NotificationsItemChatResponse',
  components: {
    StudyConversationMessageBodyText,
    StudyConversationMessageAvatar,
    StudyConversationMessageProfileName,
    LLTimestamp
  },
  props: {
    notification: { type: NotificationModel, required: true }
  },
  computed: {
    streamParameters() {
      return new StudyConversationMessageStreamParametersModel({})
    },
    options() {
      return new StudyConversationMessageOptionsModel({
        type: StudyConversationMessageType.COMMENT,
        fileSliderSize: StudyConversationMessageFileSize.SMALL
      })
    },
    message() {
      return this.notification.payload.studyReply.message
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-item-study-messagee {
  &__timestamp {
    @apply text-xs flex-shrink-0;
  }
  &__header {
    @apply flex items-center justify-between w-full;
    min-width: 0;
  }
  &__avatar {
    @apply mr-2;
  }
  &__profile {
    @apply flex items-center min-w-0 mr-2;
  }
  &__name {
    @apply min-w-0;
  }
  &__body {
    @apply mt-2 text-body-03;
  }
}
</style>
